import { Box, Typography } from '@mui/material'

function Dashboard() {
  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
      <Typography>Dashboard Page</Typography>
    </Box>
  )
}

export default Dashboard
